export default "__VITE_ASSET__e8c88e9e__"